export const BREED = [
    { label: 'Amarelo', value: 'Yellow' },
    { label: 'Branco', value: 'White'},
    { label: 'Indígena', value: 'Indigenous'},
    { label: 'Parda', value: 'Brown'},
    { label: 'Preta', value: 'Black'},
];